import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { convertImageFromDto } from "@modules/dtos/imageDto"
import { UserEntity } from "@modules/profile/userProfile/userEntity"
import { type UserProgramItemDto } from "@modules/programs/gateway/userProgramItemDto"
import { ProgramStatus, ProgramType, ProgramVisibility, SharedCoachStatus } from "@modules/programs/types/programTypes"
import { type HUImage } from "@modules/types/imageTypes"

export class UserProgramItemEntity {
  id: string
  name: string
  description: string
  image: HUImage | null
  owner: UserEntity | null
  visibility: ProgramVisibility
  subscribed: boolean
  subscriptionCount: number
  price: PriceObjectEntity | null
  defaultHideSessionContent: boolean
  status: ProgramStatus
  duration: number | null
  type: ProgramType
  sharedCoachStatus: SharedCoachStatus | null
  followedInBundle: boolean

  private constructor(program: UserProgramItemEntity) {
    this.id = program.id
    this.name = program.name
    this.description = program.description
    this.image = program.image
    this.owner = program.owner
    this.visibility = program.visibility
    this.subscribed = program.subscribed
    this.subscriptionCount = program.subscriptionCount
    this.price = program.price
    this.defaultHideSessionContent = program.defaultHideSessionContent
    this.status = program.status
    this.duration = program.duration
    this.type = program.type
    this.sharedCoachStatus = program.sharedCoachStatus
    this.followedInBundle = program.followedInBundle
  }

  static fromDto(dto: UserProgramItemDto): UserProgramItemEntity {
    return new UserProgramItemEntity({
      id: dto.id,
      name: dto.name,
      description: dto.description,
      image: dto.image ? convertImageFromDto(dto.image) : null,
      owner: dto.owner ? UserEntity.fromDto(dto.owner) : null,
      visibility: dto.visibility,
      subscribed: dto.subscribed,
      subscriptionCount: dto.subscriptionCount,
      price: dto.price ? PriceObjectEntity.fromDto(dto.price) : null,
      defaultHideSessionContent: dto.defaultHideSessionContent,
      status: dto.status,
      duration: dto.duration,
      type: dto.type,
      sharedCoachStatus: dto.sharedCoachStatus,
      followedInBundle: dto.followedInBundle,
    })
  }
}
